/* eslint-disable */
const init = () => {
    const subnavNav = document.querySelector('.subnav__nav');
    const currentPage = document.querySelector('.current-page');

    if (subnavNav && currentPage) {
        subnavNav.scrollLeft = currentPage.offsetLeft;
    }
};

export { init };
/* eslint-disable */
